import React from 'react';
import { Outlet } from 'react-router-dom';


import HeaderShare from './headerShare';
import Footer from '../footer/footer';
import ScrollToTop from '../hooks/ScrollToTop';

export default function AltLayout() {
  return (
    <>
      <HeaderShare />
      <ScrollToTop />
      <Outlet />
      <Footer />
    </>
  );
}
